import { DatePicker, Table, TableColumn, Select, Option, Checkbox, Popover, CheckboxGroup, CheckboxButton } from 'element-ui';
import { Switch as LSwitch } from '@/components/index';
import { Pagination as LPagination } from '@/components/index';
import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();

export default {
    name: 'AdminMembersTable',
    components: { LPagination, [Checkbox.name]: Checkbox, [Select.name]: Select, [Option.name]: Option, [Table.name]: Table, [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, LSwitch, [Popover.name]: Popover },
    data() {
        return {
            timerTableDataLoad: null,
            errorMessage: '',
            isViewReportMode: false,
            isLoading: false,
            activeYear: null,
            isAnyFilterUsed: false,
            isExport: false,

            searchByList: [],
            membershipCardStatusList: [],
            divisionStatusList: [],
            membershipTypeList: [],
            triathlonStatusList: [],
            exportOptions: [],
            selectedMemberListIDs: [],

            pagination: { perPageOptions: [5, 10, 25, 50, 100, 500, 1000], currentPage: 1, perPage: 5, total: 0, from: 0, to: 0 },
            tableData: [],
            params: {
                lastName: null,
                email: null,
                triathlonId: null,
                divisionStatusEnum: null,
                triathlonStatusEnum: null,
                membershipTypeEnum: null,
                membershipPaymentYear: null,
                cat1Application: false,
                accountCreatedYear: null,
                searchBy: null,
                searchQuery: null,
                membershipCardStatus: null,
                isSubscription: false,
                itemId: 0
            },
            savedParams: null,
            savedInitialParams: null,
            allYears: [],
            searchQuery: null,
            searchQueryTimer: null,
            setValue: true,

            markAsReIssuedMode: false,

            appUsersOnlyId: 4,
            subscriptionId: 5,
        };
    },
    watch: {
        searchQuery: {
            immediate: false,
            handler(val) {
                var self = this;
                clearTimeout(self.searchQueryTimer);
                self.searchQueryTimer = setTimeout(() => { self.params.searchQuery = val }, 1500);
            }
        }
    },
    computed: {
        domain() {
            return process.env.url.manegement;
        },
        loadURL() {
            return window.location.href.indexOf("v2") > -1 ? svc.generateMembersListV2 : svc.generateMembersList;
        },
        markAsReIssuedURL() {
            return window.location.href.indexOf("v2") > -1 ? svc.markAsReIssuedV2 : svc.markAsReIssued;
        }
    },
    methods: {
        //get report
        switchReport() {
            this.isExport = !this.isExport;
        },
        usedSubscriptionClick(flag) {
            this.params.isSubscription = flag;
            this.setValue = true;
        },
        addCheckboxToHeader(h, { column, $index }) {//it don't use now, but will be need if TI wants add select all
            let self = this;
            if (!self.tableData || !self.tableData.length) {
                return "";
            }

            if (self.setValue && self.params.isSubscription) {
                self.tableData.forEach(x => x.isActionAllowed = true);
                self.tableData.forEach(x => x.isChoosed = x['Accepted BMW Subscription'] == "Yes");
            }

            let allIds = self.tableData
                .filter(item => { return item.isChoosed; })
                .map(x => x['TI Number']);

            if (!allIds || !allIds.length) {
                return "";
            }
            self.selectedMemberListIDs = allIds;

            return h('div', { 'class': 'phase-header' }, [
                h('div', { 'class': 'phase-header__title' }, 'Change')
            ])
        },
        changeSelectedListIds(userId, prop) {
            var self = this;
            var index = self.selectedMemberListIDs.indexOf(userId);
            if (index > -1) {
                self.setValue = false;
                self.selectedMemberListIDs.splice(index, 1);
            }
            else {
                self.setValue = true;
                self.selectedMemberListIDs.push(userId);
            }

            self.updateSponsorsByUserId(userId, self.setValue);
        },
        async updateSponsorsByUserId(userId, val) {
            let self = this;
            let vs = false;
            self.isLoading = true;
            var data = {
                userId: userId,
                isAgreeWithBMWAgreement: val,
            };
          await svc.updateSponsorsByUserId(data)
                .then(response => {
                    self.isLoading = false;
                    if (response && response.body && response.body.isSuccess) {
                        self.$showSuccess("Is Set");
                        vs = true;
                    } else {
                        self.$showError(response);
                    }
                },
                    () => {
                        self.isLoading = false;
                        self.$showError();
                    })
            await self.queriedData(vs);
        },
        resetFilter() {
            this.params = {
                lastName: null,
                email: null,
                triathlonId: null,
                divisionStatusEnum: null,
                triathlonStatusEnum: null,
                membershipTypeEnum: null,
                membershipPaymentYear: null,
                cat1Application: false,
                accountCreatedYear: null,
                searchBy: null,
                searchQuery: null,
                membershipCardStatus: null,
                isSubscription: false
            };
            this.searchQuery = null;
        },
        membershipOnChange() {
            if (this.searchQuery == null) {
                this.params.email = null;
                this.params.triathlonId = null;
                this.params.lastName = null;
            }
        },
        exportToExcel(data) {
            if (data && data.length > 0) {
                var ws = XLSX.utils.json_to_sheet(data);
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Members");
                XLSX.writeFile(wb, "Members.xlsx");
            }
            else {
                this.$showError("Records are not loaded");
            }
        },
        getReport() {
            var self = this;
            self.isLoading = true;

            var params = self.getParams();
            params.isExport = true;
            params.exportColumnsVisibility = [];

            self.exportOptions.forEach(item => {
                if (item.isOnExport) {
                    if (item.value == "Parent") {
                        params.exportColumnsVisibility.push("Parent" + item.originValue);
                    }
                    else {
                        params.exportColumnsVisibility.push(item.originValue);
                    }
                }
            });

            params.exportColumnsVisibilityInput = params.exportColumnsVisibility.join("||");

            self.loadURL(params).then(function (resp) {
                self.isLoading = false;
                var allData = resp.body;
                if (!allData || allData.errorMessage) {

                    if (!allData.currentUserId) {
                        self.$showError("You are not authorized!");
                        setTimeout(function () {
                            self.$router.push({ path: '"/"' })
                        }, 2000)
                    }

                }

                if (allData.script) {
                    console.log(allData.script);
                }

                self.exportToExcel(allData.data);
                self.errorMessage = allData.message;
            }, () => {
                self.isLoading = false;
                self.errorMessage = "Server has not responded. Probably, connection is lost. Please try again later."
                return [];
            });
        },

        //get ctm
        getFrom() {
            if (this.pagination.total == 0) return 0;
            return (this.pagination.currentPage - 1) * this.pagination.perPage + 1;
        },
        getTo() {
            if (this.pagination.total == 0) return 0;
            if ((this.pagination.currentPage) * this.pagination.perPage > this.pagination.total) return this.pagination.total;
            return (this.pagination.currentPage) * this.pagination.perPage;
        },
        getParams() {
            switch (this.params.searchBy) {
                case 0:
                    this.params.triathlonId = null;
                    this.params.email = null;
                    this.params.lastName = null;
                    break;
                case 1:
                    this.params.triathlonId = isNaN(this.params.searchQuery) ? null : this.params.searchQuery;
                    this.params.email = null;
                    this.params.lastName = null;
                    break;
                case 2:
                    this.params.triathlonId = null;
                    this.params.email = this.params.searchQuery;
                    this.params.lastName = null;
                    break;
                case 3:
                    this.params.triathlonId = null;
                    this.params.email = null;
                    this.params.lastName = this.params.searchQuery;
                    break;
            }

            if (this.params.membershipTypeEnum && !this.params.membershipPaymentYear) {
                if (this.$refs.membershipPaymentYear.$el.getElementsByClassName('el-icon-arrow-up is-reverse').length) {
                    this.params.membershipTypeEnum = null;
                } else {
                    this.params.membershipPaymentYear = new Date().getFullYear();
                    this.params.accountCreatedYear = new Date().getFullYear();
                }
            }

            if (this.params.accountCreatedYear && this.params.membershipPaymentYear && this.params.accountCreatedYear > this.params.membershipPaymentYear) {
                if (this.$refs.accountCreatedYear.$el.getElementsByClassName('el-icon-arrow-up is-reverse').length)//opened account year
                {
                    this.params.membershipPaymentYear = this.params.accountCreatedYear;
                }
                else {
                    this.params.accountCreatedYear = this.params.membershipPaymentYear;
                }
            }

            if (this.params.membershipCardStatus == this.appUsersOnlyId && !this.params.membershipPaymentYear) {
                this.params.membershipPaymentYear = new Date().getFullYear();
            }

            var data = {
                options: {
                    take: this.pagination.perPage,
                    skip: (this.pagination.currentPage - 1) * this.pagination.perPage
                },
                lastName: this.params.lastName,
                email: this.params.email,
                triathlonId: this.params.triathlonId,
                divisionStatusEnum: this.params.divisionStatusEnum,
                triathlonStatusEnum: this.params.triathlonStatusEnum,
                membershipTypeEnum: this.params.membershipTypeEnum,
                membershipPaymentYear: this.params.membershipPaymentYear,
                cat1Application: this.params.cat1Application,
                accountCreatedYear: this.params.accountCreatedYear,
                membershipCardStatus: this.params.membershipCardStatus,
                isSubscription: this.params.isSubscription
            }

            if (data.options.skip >= this.pagination.total) {
                data.options.skip = 0;
            }

            return data;
        },
        markAsReIssued() {
            var self = this;
            self.isLoading = true;
            self.markAsReIssuedURL(self.getParams())
                .then(response => {
                    self.isLoading = false;
                    self.markAsReIssuedMode = false;
                    self.savedParams = null;
                    self.queriedData();
                    if (response && response.body && response.body.isSuccess) {
                        self.$showSuccess()
                    } else {
                        self.$showError(response);
                    }
                },
                    () => {
                        self.isLoading = false;
                        self.markAsReIssuedMode = false;
                        self.$showError();
                    })
        },
        queriedData(vs) {
            var self = this;
            var params = this.getParams();
            var paramsJson = JSON.stringify(params);

            if (paramsJson != this.savedParams || vs) {

                self.savedParams = paramsJson;
                if (!self.isLoading) {
                    return self.loadData(params);
                }
                else {
                    return self.tableData;
                }
            }
            if (self.params.isSubscription) {
                self.tableData.forEach(x => x.isActionAllowed = true);
                self.tableData.forEach(x => x.isChoosed = x['Accepted BMW Subscription'] == "Yes");
                let allIds = self.tableData
                    .filter(item => { return item.isChoosed; })
                    .map(x => x['TI Number']);
                self.selectedMemberListIDs = allIds;
            }
                        
            return self.tableData;
        },
        loadData(params) {
            var self = this;
            self.tableData = [];
            params.isNeedSupportData =
                !this.divisionStatusList || !this.divisionStatusList.length ||
                !this.membershipTypeList || !this.membershipTypeList.length ||
                !this.triathlonStatusList || !this.triathlonStatusList.length;
            self.isLoading = true;
            self.loadURL(params)
                .then(function (resp) {
                    self.isLoading = false;
                    var allData = resp.body;
                    if (!allData || allData.errorMessage) {
                        self.tableData = [];

                        if (allData && !allData.currentUserId) {
                            self.$showError("You are not authorized!");
                            setTimeout(function () {
                                self.$router.push({ path: '"/"' })
                            }, 2000)
                        }
                        return;
                    }
                    self.errorMessage = allData.message;

                    if (allData.error) {
                        self.errorMessage = allData.error;
                    }

                    if (allData.script) {
                        console.log(allData.script);
                        console.log(allData.scriptCount);
                    }

                    if (allData.divisionStatusList && allData.divisionStatusList.length) {
                        self.divisionStatusList = [];
                        self.divisionStatusList.push({ id: null, label: null, value: null });
                        Array.prototype.push.apply(self.divisionStatusList, allData.divisionStatusList);
                    }

                    if (allData.membershipTypeList && allData.membershipTypeList.length) {
                        self.membershipTypeList = [];
                        self.membershipTypeList.push({ id: null, label: null, value: null });
                        Array.prototype.push.apply(self.membershipTypeList, allData.membershipTypeList);
                    }

                    if (allData.triathlonStatusList && allData.triathlonStatusList.length) {
                        self.triathlonStatusList = [];
                        self.triathlonStatusList.push({ id: null, label: null, value: null });
                        Array.prototype.push.apply(self.triathlonStatusList, allData.triathlonStatusList);
                    }

                    if (allData.exportOptions && allData.exportOptions.length) {
                        self.exportOptions = allData.exportOptions;

                        for (var i = 0; i < 6; i++) {
                            self.exportOptions[i].readOnly = true;
                            self.exportOptions[i].isOnExport = true;
                        }
                    }

                    self.isAnyFilterUsed = allData.isAnyFilterUsed;
                    self.tableData = allData.data;

                    self.pagination.total = allData.total;
                    self.pagination.from = self.getFrom();
                    self.pagination.to = self.getTo();
                }, resp => {
                    self.isLoading = false;
                    self.errorMessage = "Server has not responded. Probably, connection is lost. Please try again later."
                    return [];
                });
            return [];
        }
    },
    created() {
        this.queriedData();
        this.allYears.push(null);
        for (var y = new Date().getFullYear() + 1; y >= 2012; y--) {
            this.allYears.push(y);
        }

        this.searchByList.push({ label: null, id: null });
        this.searchByList.push({ label: "Triathlon No", id: 1 });
        this.searchByList.push({ label: "Email", id: 2 });
        this.searchByList.push({ label: "Last Name", id: 3 });

        this.membershipCardStatusList.push({ label: "None", id: null });
        this.membershipCardStatusList.push({ label: "Marked For ReIssue", id: 1 });
        this.membershipCardStatusList.push({ label: "Chosen on Purchasing", id: 2 });
        this.membershipCardStatusList.push({ label: "Both", id: 3 });
        this.membershipCardStatusList.push({ label: "App Users Only", id: 4 });
        this.membershipCardStatusList.push({ label: "Subscriptions", id: 5 });
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/members/members-table/members-table.js